import { render, staticRenderFns } from "./WaterTopNav.vue?vue&type=template&id=5037f4c2&scoped=true&"
import script from "./WaterTopNav.vue?vue&type=script&lang=js&"
export * from "./WaterTopNav.vue?vue&type=script&lang=js&"
import style0 from "./WaterTopNav.vue?vue&type=style&index=0&id=5037f4c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5037f4c2",
  null
  
)

export default component.exports